import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CONNECT_BANNER_AND_OUTSTREAM_TO_GAM: TypedDocumentNode<Data, { input: Variables }> =
  gql`
    ${ERROR_FRAGMENT}

    mutation connectBannerAndOutstreamToGam($input: ConnectBannerAndOutstreamToGamInput!) {
      connectBannerAndOutstreamToGam(input: $input) {
        errors {
          ...ErrorFragment
        }
      }
    }
  `
